import { Boxes, GitBranch, Plus, User } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList
} from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import type { FilterDefinition, FilterType } from './types';

const ALL_FILTERS: FilterDefinition[] = [
  {
    type: 'workspace',
    label: 'Workspace',
    icon: Boxes,
    paramKey: 'workspace_id'
  },
  {
    type: 'version_group',
    label: 'Version',
    icon: GitBranch,
    paramKey: 'version_group'
  },
  { type: 'user', label: 'User', icon: User, paramKey: 'created_by' }
];

type AddFilterButtonProps = {
  activeFilterTypes: FilterType[];
  onAdd: (type: FilterType) => void;
};

export const AddFilterButton = ({
  activeFilterTypes,
  onAdd
}: AddFilterButtonProps) => {
  const [open, setOpen] = useState(false);

  const availableFilters = ALL_FILTERS.filter(
    f => !activeFilterTypes.includes(f.type)
  );

  if (availableFilters.length === 0) {
    return null;
  }

  return (
    <Popover onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <Button
          className="h-7 gap-1 rounded-md border-dashed px-2 text-xs"
          size="sm"
          variant="outline"
        >
          <Plus className="size-3.5" />
          Filter
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-48 p-0">
        <Command className="border-none shadow-none">
          <CommandList>
            <CommandGroup>
              {availableFilters.map(filter => (
                <CommandItem
                  key={filter.type}
                  onSelect={() => {
                    onAdd(filter.type);
                    setOpen(false);
                  }}
                >
                  <filter.icon className="mr-2 size-4 text-muted-foreground" />
                  {filter.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
